module.exports = "data:image/x-icon;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI1MjFjNTgxYmZkZGYzYjA2MGVkMzk4NDEwOGVkZjk1OC5pY28iOw=="


//////////////////
// WEBPACK FOOTER
// ./src/images/favicon-unread.ico
// module id = dTHV
// module chunks = 89